<template>
  <div>
    <div
      class="modal fade"
      id="ModalAggDetalleSolicitud"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalDetalle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" style="width: 100%; max-width: 100%">
          <div class="modal-header">
            <button type="button" class="close" @click="cerrarModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="row col-12">
            <div class="col-sm-4">
              <ProductoSelectComponentV2 titulo="hide" :current="filter" />
            </div>
            <div class="col-sm-4">
              <SubCategoriaSelectComponent title="hide" :current="filter" />
            </div>
            <div class="col-sm-4">
              <CategoriaSelectComponent title="hide" :current="filter" />
            </div>
          </div>
          <div class="row col-12">
            <div class="col-sm-4">
              <input
                type="text"
                placeholder="Número o barra req"
                class="form-control form-control-sm"
                v-model="filter.numero"
                @change="refreshRequisicionesPendientes()"
              />
              <br />
            </div>
            <div class="col-sm-4">
              <select
                :disabled="
                  !filter.producto &&
                  !filter.subcategoria &&
                  !filter.categoria &&
                  !filter.numero
                "
                class="form-control form-control-sm"
                v-model="filter.abc"
              >
                <option :value="null">categoría abc</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
              </select>
              <br />
            </div>
            <div class="col-sm-4">
              <ProveedoresSelectComponent titulo="hide" :current="filter" />
            </div>
          </div>
          <div class="col-12 row">
            <div class="col-4">
              <button
                @click="refreshRequisicionesPendientes()"
                class="btn btn-outline-info btn-block"
              >
                <i class="fas fa-search"></i> Buscar
              </button>
            </div>
            <div class="col-4">
              <button @click="resetFilters()" class="btn btn-outline-dark btn-block">
                <i class="fas fa-sync"></i> Reset
              </button>
            </div>
            <div class="col-4">
              <button
                :disabled="!reqs_list[0]"
                @click="agregarTodoDetalle(reqs_list)"
                class="btn btn-outline-success btn-block"
              >
                Agg Todo
              </button>
            </div>
          </div>
          <br />
          <h6 class="text-center text-success">Solicitudes Abiertas</h6>
          <div
            style="overflow-y: scroll; max-height: 60vh"
            class="modal-body invoice-table"
          >
            <table class="table table-striped table-lightborder">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th class="text-right">Cant. abierta</th>
                  <th class="text-right">Exist. origen</th>
                  <th class="text-right">Exist. destino</th>
                  <th class="text-center">Fecha</th>
                  <th class="text-center">#</th>
                  <th class="text-center">Usuario</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr class="project-box" v-for="det in reqs_list" :key="det.id">
                  <td class="font-weight-bold">
                    {{ det.producto_id }}
                    <br />
                    <small>{{ det.nombre_producto }}</small>
                  </td>
                  <td class="text-right">{{ det.cantidad_abierta }}</td>
                  <td class="text-right">{{ det.existencia_cedis }}</td>
                  <td class="text-right">{{ det.existencia }}</td>
                  <td class="text-center">
                    {{ det.fecha_creacion | moment("DD/MM/YYYY") }}
                  </td>
                  <td class="text-right">{{ det.numero }}</td>
                  <td class="text-right">{{ det.username }}</td>
                  <td class="text-right">
                    <button
                      @click="AgregarLineaSolicitud(det.id)"
                      class="btn btn-sm btn-info"
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import DynamicService from "../../../services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    ProductoSelectComponentV2,
    SubCategoriaSelectComponent,
    TiendaSelectComponent,
    CategoriaSelectComponent,
    ProveedoresSelectComponent,
  },
  props: {
    reqs_pendientes: {
      type: Array,
      required: true,
    },
    tarea: {
      type: Object,
      required: true,
    },
  },
  watch: {
    reqs_pendientes: function () {
      this.reqs_list = this.reqs_pendientes;
    },
  },
  data() {
    return {
      tipo_filtro: "scaner",
      current: {},
      currentDetalle: {},
      filter: { abc: null },
      reqs_list: [],
      params: {},
    };
  },
  methods: {
    cambiarTipo() {
      let self = this;
      if (self.tipo_filtro == "scaner") {
        self.tipo_filtro = "numero";
      } else {
        self.tipo_filtro = "scaner";
      }
    },
    agregarTodoDetalle(det) {
      let self = this;
      DynamicService.postAction(
        "wms",
        "tareas",
        self.tarea.id,
        "agregar_lista_detalle_tarea_manual",
        det
      )
        .then((response) => {
          this.$emit("refreshCurrent");
          Notifications.toast.success(
            "Agregar lista detalle solicitud",
            "Realizado Exitosamente"
          );
          $("#ModalAggDetalleSolicitud").modal("hide");
          self.resetFilters();
          self.refreshRequisicionesPendientes();
        })
        .catch((error) => {
          Notifications.alert.error(
            "Agregar linea solicitud",
            error.response.data.detail
          );
        });
    },
    resetFilters() {
      let self = this;
      self.filter.producto = null;
      self.filter.subcategoria = null;
      self.filter.categoria = null;
      self.filter.numero = null;
      self.filter.abc = null;
      self.params = {};
      self.reqs_list = self.reqs_pendientes;
    },
    cerrarModal() {
      let self = this;
      self.resetFilters();
      $("#ModalAggXReq").modal("hide");
      $("#ModalAggDetalleSolicitud").modal("hide");
    },
    refreshRequisicionesPendientes() {
      let self = this;
      let params = {};
      if (self.filter.numero) {
        params.numero = self.filter.numero;
      }
      if (self.tarea.tienda_pedir) {
        params.tienda_origen = self.tarea.tienda_pedir;
      }
      if (self.filter.abc) {
        params.abc = self.filter.abc;
      }
      if (self.tarea.tienda_destino) {
        params.tienda_destino = self.tarea.tienda_destino;
      }
      if (self.filter.producto) {
        params.producto = self.filter.producto.sku;
      }
      if (self.filter.subcategoria) {
        params.subcategoria = self.filter.subcategoria.codigo;
      }
      if (self.filter.categoria) {
        params.categoria = self.filter.categoria.codigo;
      }
      console.log(params);
      DynamicService.getActionList(
        "wms",
        "tareas",
        "obtener_reqs_para_tarea_manual",
        params
      ).then((response) => {
        if (response.data == null) {
          self.reqs_list = "";
        } else {
          self.reqs_list = response.data;
          self.params = {};
        }
      });
    },
    AgregarLineaSolicitud(id) {
      let self = this;
      DynamicService.postAction(
        "wms",
        "tareas",
        self.tarea.id,
        "agregar_linea_tarea_manual",
        {
          id: id,
        }
      )
        .then((response) => {
          this.$emit("refreshCurrent");
          Notifications.toast.success(
            "Agregar linea solicitud",
            "Realizado Exitosamente"
          );
          self.refreshRequisicionesPendientes();
        })
        .catch((error) => {
          Notifications.alert.error(
            "Agregar linea solicitud",
            error.response.data.detail
          );
        });
    },
  },
};
</script>
